import {Component, OnInit} from '@angular/core';
import {UserQueriesService} from './user-queries.service';
import {AuthService} from '../../auth.service';
import {TranslateService} from '../../../shared/translate.service';
import {UserQueriesDatasource} from './user-queries-datasource';
import {BaseUserTableView} from '../base-user-table-view';
import {UserQueryDtoInterface} from './dto/user-query-dto';
import {FilterUserQueryDto} from './dto/filter-user-query-dto';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {HtmlUtilsService} from '../../../html-utils/html-utils.service';
import {AppConfigService} from '../../../config/app-config.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../messages/message.service';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {UserQueryComponent} from './user-query/user-query.component';
import {UserNotificationService} from '../../notification/user-notification.service';

@Component({
  selector: 'app-user-queries',
  templateUrl: './user-queries.component.html',
  styleUrls: ['./user-queries.component.scss', '../user-collections/user-collections.component.scss']
})
export class UserQueriesComponent extends BaseUserTableView<UserQueryDtoInterface, FilterUserQueryDto>{

  displayedColumns = ['id', 'title', 'note',  'itemsCount', 'options'];
  readonly sortDirections = ['asc', 'desc'];
  readonly timePeriodOptions = ['DAILY', 'WEEKLY', 'MONTHLY'];
  readonly languageOptions = ['pl', 'en'];


  titleField = new FormControl();
  noteField = new FormControl();
  itemsCountFromField = new FormControl();
  itemsCountToField = new FormControl();

  timePeriodValue = '';
  titleFieldValue = '';
  noteFieldValue = '';
  language = "";
  itemsCountFromFieldValue = null;
  itemsCountToFieldValue = null;
  tagsFieldValue = '';

  sortActive = false;

  constructor(protected userService: UserQueriesService, public translator: TranslateService,
              protected authService: AuthService, protected route: ActivatedRoute, public htmlUtils: HtmlUtilsService,
              protected router: Router, protected configService: AppConfigService,
              protected modalService: NgbModal, protected messageService: MessageService,
              private notificationService: UserNotificationService) {
    super(translator, configService, router, route, modalService, messageService, authService, userService);
    this.dataSource = new UserQueriesDatasource(this.userService, this.authService);
  }

  toggleSort() {
    this.sortActive = !this.sortActive;
  }

  getPrefix(): string {
    return 'object';
  }

  loadMore() {
    this.dataSource.loadCollections(this.page, this.pageSize, this.sort, this.direction, {
      title: this.titleFieldValue, note: this.noteFieldValue, itemCountFrom: this.itemsCountFromFieldValue,
      itemCountTo: this.itemsCountToFieldValue
    });
  }

  loadEmailNotificationPeriod() {
    this.authService.getToken().then(token => {
      this.userService.loadEmailNotificationPeriod(token).then(value => {
        if (value && value.timePeriod) {
          this.timePeriodValue = value.timePeriod;
        }
        if (value && value.language) {
          this.language = value.language;
        }
    });
    });
  }

  onTimePeriodChange() {
    this.authService.getToken().then(token => {
      this.userService.saveEmailNotificationPeriod(this.timePeriodValue,this.language, token).then(value => {
      });
    });
  }

  markNotificationAsRead(queryId) {
    this.authService.getToken().then(token => {
      this.notificationService.markAsRead(queryId, token).subscribe(value => {
      });
    });
  }

  createChilds(element: string): string[] {
    if (element){
      if (element.indexOf(' ')>0){
        return element.split(' ');
      }else{
        return [element];
      }
    }
    return [];
  }


  openEditModal(element: UserQueryDtoInterface){
    const modal = this.modalService.open(UserQueryComponent);
    modal.componentInstance.userQueryDto = element;
    modal.result.then(value => {
      if (value) {
        this.authService.getToken().then(token => {
          this.userService.handleSaveUserQuery(value, token).then(userQueryDto => {
            if (userQueryDto) {
              element.title = userQueryDto.title;
              element.note = userQueryDto.note;
            }
          });
        });
      }
    });
  }

  onSortChange(){
    this.navigateByParams();
  }

  sortByKeys(sortables) {
    return  Array.from(sortables.keys());
  }

  updateQuery(query: UserQueryDtoInterface) {
    query.notification = !query.notification;
    this.authService.getToken().then(token => {
      this.userService.handleSaveUserQuery(query, token).then(userQueryDto => {
        if (userQueryDto) {
          query.notification = userQueryDto.notification;
        }
      });
    });
  }

  protected getDeletePrefix(): string {
    return 'UserQuery.delete';
  }

  protected initFilters() {
    this.loadEmailNotificationPeriod();
    this.titleField.setValue(this.titleFieldValue);
    this.noteField.setValue(this.noteFieldValue);
    this.itemsCountFromField.setValue(this.itemsCountFromFieldValue);
    this.itemsCountToField.setValue(this.itemsCountToFieldValue);

    this.titleField.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()).subscribe(value => {
      this.titleFieldValue = value;
      this.navigateByParams();
    });
    this.noteField.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()).subscribe(value => {
      this.noteFieldValue = value;
      this.navigateByParams();
    });
    this.itemsCountFromField.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()).subscribe(value => {
      this.itemsCountFromFieldValue = value;
      this.navigateByParams();
    });
    this.itemsCountToField.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()).subscribe(value => {
      this.itemsCountToFieldValue = value;
      this.navigateByParams();
    });
  }

  protected navigateByParams() {
    if (this.page>this.totalPages){
      this.page = this.totalPages;
    }else if (this.page<1){
      this.page = 1;
    }
    const queryParams = {
      page: this.page, pageSize: this.pageSize, sort: this.sort, direction: this.direction,
      title: this.titleFieldValue, note: this.noteFieldValue, itemCountFrom: this.itemsCountFromFieldValue,
      itemCountTo: this.itemsCountToFieldValue
    };
    if (this.itemsCountFromFieldValue) {
      queryParams['itemCountFrom'] = this.itemsCountFromFieldValue + '';
    }
    if (this.itemsCountToFieldValue) {
      queryParams['itemCountTo'] = this.itemsCountToFieldValue + '';
    }
    this.router.navigate(['/queries'], {
      queryParams: queryParams
    });
  }

  protected populateQueryParams(params: ParamMap) {
    const queryPageSize = params.get('pageSize');
    const querySort = params.get('sort');
    const queryDirection = params.get('direction');
    const page = params.get('page');
    this.titleFieldValue = params.get('title');
    this.noteFieldValue = params.get('note');
    this.itemsCountFromFieldValue = params.get('itemCountFrom');
    this.itemsCountToFieldValue = params.get('itemCountTo');

    if (queryPageSize && this.pageSizeOptions.indexOf(+queryPageSize)) {
      this.pageSize = +queryPageSize;
    }
    if (querySort && this.displayedColumns.indexOf(querySort)) {
      this.sort = querySort;
    }
    if (page && +page > 0) {
      this.page = +page;
    }
    if (queryDirection && (queryDirection === 'asc' || queryDirection === 'desc')) {
      this.direction = queryDirection;
    }

    this.dataSource.loadCollections(this.page, this.pageSize, this.sort, this.direction,
      {
        title: this.titleFieldValue, note: this.noteFieldValue, itemCountFrom: this.itemsCountFromFieldValue,
        itemCountTo: this.itemsCountToFieldValue
      });
  }


}
